import PropTypes from 'prop-types';
import React from 'react';
import { modelNameTransformer } from 'pubweb-smokey/dist/utils/modelNameTransformer';
import { formatNumberWithCommas } from 'pubweb-smokey/dist/utils/formatters';
import { DXFavoritesContext } from '@contexts/DXFavoritesContext';
import FavoritingHeart from '@components/Shared/Favoriting/FavoritingHeart';
import HomeSpecs from './HomeSpecs';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';
import { HeadingDesktopStyles } from './HeadingDesktop.styled';
import ActionButtons from './ActionButtons';
import TopFavoriteBanner from './TopFavoriteBanner';

const HeadingDesktop = ({
  homeDetails,
  price,
  isInStock,
  isPriceLoading,
  onRequestInfoClick,
  onFindRetailerClick,
  epicSlug,
}) => {
  /* eslint-disable react/no-unescaped-entities */
  return (
    <HeadingDesktopStyles>
      <div className="home-details-heading home-details-heading-desktop">
        <div className="name-action-buttons">
          <div className="name-favoriting">
            <div className="favoriting-heart-container">
              <DXFavoritesContext.Consumer>
                {({ state, actions }) => {
                  return (
                    <FavoritingHeart
                      isFavorited={
                        !!state.favoriteModels?.filter(
                          (faveModels) =>
                            faveModels.modelNumber === homeDetails.modelNumber
                        )[0]
                      }
                      onClick={() => {
                        actions.toggleFavoriteModel(homeDetails.modelNumber);
                        pushGTMEvent('clickFavoritesHeart');
                      }}
                    />
                  );
                }}
              </DXFavoritesContext.Consumer>
            </div>

            <div className="home-info">
              {isInStock && (
                <div className="stock-indicator label">
                  <div className="in-stock-dot">&nbsp;</div> In Stock
                </div>
              )}

              <h1 className="h2">
                {modelNameTransformer(homeDetails.modelDescription)}
              </h1>

              <div className="home-specs-container">
                {price && (
                  <>
                    <h5 className="price-heading">
                      ${formatNumberWithCommas(price)}'s* Before Options
                    </h5>
                    <div className="divider">|</div>
                  </>
                )}

                {isPriceLoading && (
                  <div className="price-heading-loading">&nbsp;</div>
                )}

                <HomeSpecs homeDetails={homeDetails} />
              </div>
              <div className="see-below">
                <span
                  tabIndex="0"
                  onClick={() => {
                    document.getElementById('disclaimer').scrollIntoView();
                  }}
                >
                  See below for complete pricing details
                </span>
              </div>
            </div>
          </div>

          <div className="desktop-action-buttons">
            <ActionButtons
              onRequestInfoClick={onRequestInfoClick}
              onFindRetailerClick={onFindRetailerClick}
              epicSlug={epicSlug}
            />
          </div>
        </div>
        <TopFavoriteBanner modelNumber={homeDetails?.modelNumber} />
      </div>
    </HeadingDesktopStyles>
  );
  /* eslint-enable react/no-unescaped-entities */
};

HeadingDesktop.propTypes = {
  epicSlug: PropTypes.any,
  homeDetails: PropTypes.shape({
    modelDescription: PropTypes.any,
    modelNumber: PropTypes.any,
  }),
  isInStock: PropTypes.any,
  isPriceLoading: PropTypes.any,
  onFindRetailerClick: PropTypes.any,
  onRequestInfoClick: PropTypes.any,
  price: PropTypes.any,
};

export default HeadingDesktop;
